import { render } from "./IconGrid.vue?vue&type=template&id=0f1b120a"
import script from "./IconGrid.vue?vue&type=script&lang=js"
export * from "./IconGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__